import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { observer, useLocalStore } from 'mobx-react-lite';
import MaterialTable, { Column } from 'material-table';
import { IconButton, Tooltip } from '@material-ui/core';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CachedIcon from '@material-ui/icons/Cached';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import GetAppIcon from '@material-ui/icons/GetApp';

import { Conteudo, NewBody } from '../../../components/Body';
import Botao from '../../../components/Botoes/Botao';
import { Flex } from '../../../components/NavBar/styles';
import { newConfigRacoes } from '../../../components/Tabela';
import Formatter from '../../../services/Formatter';
import useStore from '../../../services/hooks/useStore';
import { apiMain, aqReports } from '../../../services/utils';
import useModal from '../../../services/hooks/useModal';
import SelecionarLoteTanques from './crescimento/SelecionarLoteTanques';
import SelecionarLote from './crescimento/SelecionarLote';
import { permissoes } from '../../../services/utils/permissoes';

const ResumoTotalInsumos: React.FC = () => {
  const store = useStore();

  const modalSelecionarLote = useModal();
  const modalTanques = useModal();

  const history = useHistory();
  store.propriedade && store.validarPermissao(permissoes.PAINEL_ZOOTECNICO_LEITURA, history);

  const state = useLocalStore(() => ({
    lote: null as SelectRow | null,
    tanque: null as SelectRow | null,
    codigo: '',
    id: {
      lote: null as any,
      tanque: null as any,
    },
    data_ini: null as MaterialUiPickersDate,
    data_fim: null as MaterialUiPickersDate,

    lotes: [] as SelectRow[],
    tanques: [] as SelectRow[],

    rows: [] as object[],
    totais: 0,
    sync: false,
  }));
  const columns: Column<object>[] = [
    {
      field: 'lote_codigo',
      title: 'Lotes',
    },
    {
      field: 'tanque_nome',
      title: 'Tanques',
    },
    {
      field: 'insumo_nome',
      title: 'Insumos',
    },
    {
      field: 'total',
      title: 'TOTAL INSUMOS (KG)',
      type: 'numeric',
      render: (rowData: any) => {
        return Formatter.formatNumber(3, rowData.total);
      },
    },
  ];

  async function sync(): Promise<void> {
    store.toggleLoader();

    await store.lotes.populate();
    await store.loteTanque.populate();

    state.lotes = store.lotes.map((item) => {
      return {
        label: item.nome,
        value: item.uuid,
      };
    });

    state.tanques = store.loteTanque.map((item) => {
      return {
        label: item.tanque.nome ? item.tanque.nome : item.tanque.codigo,
        value: item.uuid,
      };
    });

    state.sync = true;

    store.toggleLoader();
  }

  async function getRelatorio(): Promise<void> {
    if ((state.data_ini && !state.data_fim) || (state.data_fim && !state.data_ini)) {
      store.notificar('Informe a data inicial e a final do período');
    } else {
      store.toggleLoader();

      if (state.lote || state.tanque) {
        const response = await aqReports.get(`/insumo/${store.propriedade?.uuid}/resumo-consumo`, {
          params: {
            lote: state.lote ? state.lote.value : undefined,
            lotetanque: state.tanque ? state.tanque.value : undefined,
            data_inicio: state.data_ini ? Formatter.dateToString(state.data_ini, '/') : undefined,
            data_fim: state.data_fim ? Formatter.dateToString(state.data_fim, '/') : undefined,
          },
        });

        state.rows = response.data.results;
        state.totais = response.data.total;
      }

      store.toggleLoader();
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  async function getCSV() {
    try {
      const pdf = await apiMain.get(`/gerador/csv/insumo/${store.propriedade?.id}/resumo-consumo`, {
        params: {
          authori: store.token,
          lote: state.id ? state.id.lote : undefined,
          lotetanque: state.id ? state.id.tanque : undefined,
          data_inicio: state.data_ini ? Formatter.dateToString(state.data_ini, '/') : undefined,
          data_fim: state.data_fim ? Formatter.dateToString(state.data_fim, '/') : undefined,
        },
      });
      window.open(pdf.request.responseURL, '_blank');
    } catch {
      store.notificar('Houve algum problema ao gerar o PDF! Favor entrar em contato com o Suporte.');
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  async function getPDF() {
    try {
      const pdf = await apiMain.get(`/gerador/pdf/insumo/${store.propriedade?.id}/resumo-consumo`, {
        params: {
          authori: store.token,
          lote: state.id ? state.id.lote : undefined,
          lotetanque: state.id ? state.id.tanque : undefined,
          data_inicio: state.data_ini ? Formatter.dateToString(state.data_ini, '/') : undefined,
          data_fim: state.data_fim ? Formatter.dateToString(state.data_fim, '/') : undefined, 
        },
      });
      window.open(pdf.request.responseURL, '_blank');
    } catch {
      store.notificar('Houve algum problema ao gerar o PDF! Favor entrar em contato com o Suporte.');
    }
  }

  function limparFiltros(): void {
    state.lote = null;
    state.tanque = null;
    state.data_ini = null;
    state.data_fim = null;
    state.rows = [];
    state.totais = 0;
  }

  // eslint-disable-next-line
  useEffect(() => store.setTitulo('Resumo do Consumo de Insumos'), []);

  useEffect(() => {
    store.propriedade && sync();
    // eslint-disable-next-line
  }, [store.propriedade]);

  return state.sync ? (
    <NewBody>
      <Flex style={{ justifyContent: 'space-between' }}>
        <Link
          to={'/relatorios/relatorios-zootecnicos'}
          style={{ color: '#049CE7', textDecoration: 'none', fontFamily: 'Roboto' }}
        >
          <Flex>
            <img src={'/images/returnArrow.svg'} />
            <div style={{ paddingLeft: '5px', fontFamily: 'Roboto', color: '#049CE7' }}>Lista de Relatórios</div>
          </Flex>
        </Link>

        <h2>
          Resumo - {state.lote ? `Lote:  ${state.lote.label}` : ''}{' '}
          {state.tanque ? `Lote:  ${state.codigo} ${'-'} Tanque:  ${state.tanque.label}` : ''}{' '}
        </h2>

        <Flex>
          <Tooltip title="Exportar para CSV">
            <IconButton className="blue" onClick={getCSV}>
              <GetAppIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Baixar PDF">
            <IconButton className="blue" onClick={getPDF}>
              <AssignmentIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Sincronizar">
            <IconButton
              className="blue"
              onClick={() => {
                sync();
                getRelatorio();
              }}
            >
              <CachedIcon />
            </IconButton>
          </Tooltip>
        </Flex>
      </Flex>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 300px', gap: 10 }}>
        <Conteudo style={{ padding: 0 }}>
          <MaterialTable
            columns={columns}
            data={state.rows}
            options={{
              ...newConfigRacoes.options,
              paging: false,
            }}
            localization={newConfigRacoes.localization}
            style={newConfigRacoes.style}
          />
          <Flex
            style={{
              width: '100%',
              padding: '1rem',
              justifyContent: 'space-between',
              alignItems: 'center',
              margin: '0 auto',
              marginBottom: '-15px',
              border: '1px solid #999',
            }}
          >
            <p>TOTAL GERAL (KG)</p>

            <strong>{Formatter.formatNumber(3, state.totais)} </strong>
          </Flex>
        </Conteudo>

        <Conteudo>
          <div style={{ width: '100%', marginBottom: 10 }}>
            <Botao disabled={state.tanque !== null} onClick={() => modalSelecionarLote.open()}>
              Adicionar Lote
            </Botao>
          </div>

          <div style={{ width: '100%', marginBottom: 10 }}>
            <Botao disabled={state.lote !== null} onClick={() => modalTanques.open()}>
              Adicionar Tanque
            </Botao>
          </div>

          <KeyboardDatePicker
            autoOk
            disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            label="Data Inicial"
            value={state.data_ini}
            onChange={(date) => (state.data_ini = date!)}
          />

          <KeyboardDatePicker
            autoOk
            disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            label="Data Final"
            value={state.data_fim}
            onChange={(date) => (state.data_fim = date!)}
          />

          <Botao disabled={!state.tanque && !state.lote} onClick={getRelatorio} cor="#00C853">
            Gerar Relatório
          </Botao>
          <Botao onClick={limparFiltros} cor="#FC7467">
            Limpar Filtros
          </Botao>
        </Conteudo>

        {/* <Conteudo overflowY>
          <ReactApexChart options={graficoDonut.options} series={graficoDonut.series} type="donut" height="300px" />
        </Conteudo> */}
      </div>

      {modalSelecionarLote.state ? (
        <SelecionarLote
          state={state}
          open={modalSelecionarLote.state}
          handleClose={modalSelecionarLote.close}
          onItemClick={(lote) => {
            state.tanques = [];
            state.lote = { label: lote.codigo, value: lote.uuid };
            state.id = {
              lote: lote.id,
              tanque: '',
            };
          }}
          loteID={state.lote ? parseInt(state.lote.value) : null}
        />
      ) : null}

      {modalTanques ? (
        <SelecionarLoteTanques
          open={modalTanques.state}
          handleClose={modalTanques.close}
          setTanque={(tanque) => {
            state.tanque = { label: tanque.label, value: tanque.value };
            state.id = {
              lote: '',
              tanque: tanque.loteTanque,
            };
            state.codigo = tanque.tanque;
          }}
          setLote={(lote) => console.log(lote)}
          state={state}
          exclude={[]}
        />
      ) : null}
    </NewBody>
  ) : null;
};

export default observer(ResumoTotalInsumos);
